import React, { useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  InputNumber,
  Space,
  Divider,
  Button,
  Popconfirm,
  Tooltip,
  Tag,
  Card,
  message,
  Popover,
  Checkbox,
} from "antd";
import {
  FileTextOutlined,
  CalendarOutlined,
  DollarOutlined,
  TeamOutlined,
  CloseOutlined,
  SaveOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import MoneyInput from "./MoneyInput";
import DefendantCheckboxGroup from "./DefendantCheckboxGroup";
import FormPaymentSection from "./FormPaymentSection";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { optionsInterest } from "../../../../utils/constant/Interest";
import { FORM_LAYOUT } from "../constants";
import { optionsMonth } from "../../../../utils/constant/MonthSelect";
import { contentPopOver } from "../hooks/ContentPopOver";
import dayjs from "dayjs";

const { TextArea } = Input;

const FormJudge1 = ({
  form,
  onFinish,
  onFinishFailed,
  onChangeDate,
  onChangeJudgement,
  onChangeDateAgreement,
  radioDecide,
  radioFinish,
  dataDefault,
  checkboxTab1,
  allDefendants,
  customerCustomerId,
  handleCheckboxTab1Change,
  onAddDefendantClick,
  handleCancel,
  setTabsKey,
  loading,
  mergedArrow,
  saveFormDataTab1,
  disabledDefendants,
  onChangeCheckBoxAll,
}) => {
  const showNextButton = radioDecide === "enforce";

  // Track ค่าทั้งสอง field
  const interestRate1Value = Form.useWatch("interestRate1", form);
  const judgementLack1Value = Form.useWatch("judgementLack1", form);
  const interestRateJudgeLack1Value = Form.useWatch(
    "interestRateJudgeLack1",
    form,
  );
  const payDueValue = Form.useWatch("paymentDue", form);
  const interestRateCostUnless1Value = Form.useWatch(
    "interestRateCostUnless1",
    form,
  );
  const costUnless1Value = Form.useWatch("costUnless1", form);

  // คำนวณว่าควร disable หรือไม่
  const hasInterestRate1 =
    interestRate1Value !== undefined &&
    interestRate1Value !== null &&
    interestRate1Value >= 0;
  const hasJudgementLack1 =
    judgementLack1Value !== undefined &&
    judgementLack1Value !== null &&
    judgementLack1Value !== "" &&
    interestRateJudgeLack1Value > 0;
  const newContno = dataDefault.newContno
    ? dataDefault.newContno
    : dataDefault.CONTNO.includes("-")
      ? "V" + dataDefault.CONTNO
      : "V-" + dataDefault.CONTNO;

  const isDisabledLack1 = hasInterestRate1;
  const isDisabledInterestRate1 = hasJudgementLack1;

  // ✅ Clear ค่าเมื่อถูก disabled (Optional)
  useEffect(() => {
    if (hasInterestRate1) {
      form.setFieldsValue({
        interestRateJudgeLack1: null,
      });
    }

    if (hasJudgementLack1) {
      form.setFieldsValue({
        interestRate1: null,
      });
    }
    if (radioDecide !== "enforce") {
      form.setFieldsValue({
        delayCostUnless1: null,
      });
    }
    if (!costUnless1Value) {
      form.setFieldsValue({
        interestRateCostUnless1: null,
      });
    }
  }, [
    hasInterestRate1,
    isDisabledInterestRate1,
    form,
    radioDecide,
    hasJudgementLack1,
    costUnless1Value,
  ]);

  // ✅ Handler สำหรับกดถัดไป - บันทึกข้อมูล Tab1 ก่อน
  const handleNextTab = async () => {
    try {
      // ✅ 1. Validate form ก่อน
      const values = await form.validateFields();
      console.log("✅ Validation passed:", values);

      // ✅ 2. บันทึกข้อมูล Tab1
      saveFormDataTab1();

      // ✅ 3. Blur focus ก่อนเปลี่ยน tab
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      // ✅ 4. เปลี่ยนไป Tab2
      setTimeout(() => {
        setTabsKey("2");
      }, 50);
    } catch (error) {
      // ✅ แสดง error ถ้า validation ไม่ผ่าน
      if (error.errorFields && error.errorFields.length > 0) {
        message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน");

        // Scroll ไปที่ field แรกที่ error
        const firstErrorField = error.errorFields[0].name;
        requestAnimationFrame(() => {
          form.scrollToField(firstErrorField);
        });
      } else {
        console.error("Error:", error);
        message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    }
  };

  const onChangePaydue = (value) => {
    form.setFieldsValue({ judgement1: value });
  };

  const onChangejudgementLack1Value = (value) => {
    if (value > 0) {
      form.setFieldsValue({
        interestRate1: null,
        interestRateJudgeLack1: 15 / 100,
      });
    } else {
      form.setFieldsValue({
        interestRate1: 15 / 100,
        interestRateJudgeLack1: null,
      });
    }
  };

  // ========================================
  // Upload Props
  // ========================================

  return (
    <Card style={{ borderRadius: 8 }}>
      <Form
        {...FORM_LAYOUT}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          memo: null,
          costUnless1: null,
          interest: null,
          costPermonth1: null,
          costDay1: null,
          trackingFeeEnforce: null,
          lawyerFeeEnforce: null,
          governmentOfficer1: [],
          newContnoCustom: newContno,
        }}
        // ✅ เพิ่ม scrollToFirstError
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
        }}
      >
        {/* ข้อมูลคำพิพากษา */}
        <Divider orientation="left">
          <FileTextOutlined /> ข้อมูลคำพิพากษา
        </Divider>
        <Form.Item label="วันประทับฟ้อง">
          {dataDefault.dateOfPlaint
            ? dayjs(dataDefault.dateOfPlaint)
                .add(543, "year")
                .format("DD MMMM YYYY")
            : "-"}
        </Form.Item>

        <Form.Item
          label="วันที่พิพากษา"
          name="enforceCaseDate"
          rules={[{ required: true, message: "กรุณาเลือกวันที่" }]}
        >
          <ThaiDatePicker
            onChange={onChangeDate}
            placeholder="กรุณาเลือกวันที่"
            size="large"
            style={{ width: "100%" }}
            suffixIcon={<CalendarOutlined />}
          />
        </Form.Item>

        <Form.Item
          label="เลขคดีแดง"
          name="redNumber"
          rules={[{ required: true, message: "กรุณาพิมพ์เลขคดีแดง !" }]}
        >
          <Input
            size="large"
            placeholder="กรอกเลขคดีแดง"
            suffix={<FileTextOutlined />}
          />
        </Form.Item>
        <Form.Item
          label="เลขสัญญาใหม่"
          name="newContnoCustom"
          rules={[{ required: true, message: "กรุณาพิมพ์เลขสัญญาใหม่ !" }]}
        >
          <Input
            size="large"
            placeholder="กรอกเลขสัญญาใหม่"
            suffix={<FileTextOutlined />}
            // defaultValue={newContno}
          />
        </Form.Item>
        {/* การชำระเงิน (ถ้าทำยอม) */}
        {radioDecide === "agreement" && (
          <FormPaymentSection
            form={form}
            radioDecide={radioDecide}
            radioFinish={radioFinish}
            onChangeDateAgreement={onChangeDateAgreement}
            onChangePaydue={onChangePaydue}
          />
        )}

        {/* ดอกเบี้ยและค่าขาดประโยชน์ */}
        <Divider orientation="left">
          <DollarOutlined /> ดอกเบี้ยและค่าขาดประโยชน์
        </Divider>

        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label="ค่าชดใช้แทน"
              name="judgement1"
              rules={[{ required: true, message: "กรุณาใส่คำพิพากษา !" }]}
              labelCol={{ span: 12 }}
            >
              <MoneyInput
                placeholder="จำนวนเงินที่จำเลยต้องชำระ"
                // onChange={onChangeJudgement}
                disabled={payDueValue}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("interestRate1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้เลือกอัตราดอกเบี้ย/ปี
                </span>
              }
              name="interestRate1"
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="เลือกอัตราดอกเบี้ย"
                popupMatchSelectWidth={false}
                allowClear
                disabled={isDisabledInterestRate1}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("judgementLack1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ต้นเงิน
                </span>
              }
              name="judgementLack1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput
                placeholder="ไม่มีไม่ต้องกรอก"
                // disabled={isDisabledLack1}
                onChange={onChangejudgementLack1Value}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("interestRateJudgeLack1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้เลือกอัตราดอกเบี้ย/ปี
                </span>
              }
              name="interestRateJudgeLack1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="เลือกอัตราดอกเบี้ย/ปี"
                popupMatchSelectWidth={false}
                allowClear
                disabled={isDisabledLack1} // ✅ disabled เมื่อเลือกดอกเบี้ย
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("dateInterest1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  วันเริ่มคิดดอกเบี้ย/ปี
                </span>
              }
              rules={[
                {
                  required:
                    (interestRate1Value || interestRateJudgeLack1Value) &&
                    radioDecide === "enforce"
                      ? true
                      : false,
                  message: "กรุณาใส่วันที่เริ่มคิดดอกเบี้ย} !",
                },
              ]}
              name="dateInterest1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <ThaiDatePicker
                onChange={onChangeDate}
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("costUnless1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ค่าขาดประโยชน์
                </span>
              }
              name="costUnless1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput placeholder="ไม่มีไม่ต้องกรอก" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("interestRateCostUnless1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้อัตราดอกเบี้ย/ปี
                </span>
              }
              name="interestRateCostUnless1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="อัตราดอกเบี้ย"
                popupMatchSelectWidth={false}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("dateInterestCostUnless1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  วันเริ่มคิดดอกเบี้ย(ค่าขาดประโยชน์)
                </span>
              }
              name="dateInterestCostUnless1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
              rules={[
                {
                  required:
                    interestRateCostUnless1Value && radioDecide === "enforce"
                      ? true
                      : false,
                  message: "กรุณาใส่วันที่เริ่มคิดดอกเบี้ย} !",
                },
              ]}
            >
              <ThaiDatePicker
                onChange={onChangeDate}
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("delayCostUnless1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ไม่เกิน
                </span>
              }
              name="delayCostUnless1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <InputNumber
                min={0}
                suffix="วัน"
                size="large"
                placeholder="ใส่เป็นจำนวนวันเท่านั้น"
                style={{ width: "100%", color: "black" }}
                disabled={radioDecide !== "enforce"}
              />
              {/* <Select
                showSearch
                size="large"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                optionFilterProp="label"
                options={optionsMonth}
                placeholder="เลือกจำนวนเดือน"
                suffix="เดือน"
                allowClear
              /> */}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("costPermonth1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ค่าขาดประโยชน์เดือนละ
                </span>
              }
              name="costPermonth1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput placeholder="ไม่มีไม่ต้องกรอก" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver("costDay1")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ไม่เกิน
                </span>
              }
              name="costDay1"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              {/* <InputNumber
                min={0}
                suffix="วัน"
                size="large"
                placeholder="ใส่เป็นจำนวนวันเท่านั้น"
                style={{ width: "100%", color: "black" }}
              /> */}
              <Select
                showSearch
                size="large"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                optionFilterProp="label"
                options={optionsMonth}
                placeholder="เลือกจำนวนเดือน"
                suffix="เดือน"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        {radioDecide === "enforce" && (
          <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
            <Col span={12}>
              <Form.Item
                label="วันดิว"
                rules={[
                  {
                    required: true,
                    message: "กรุณาใส่วันที่เริ่มคิดดอกเบี้ย !",
                  },
                ]}
                name="fDate"
                style={{ marginBottom: 0 }}
                labelCol={{ span: 12 }}
              >
                <ThaiDatePicker
                  name="fDate"
                  onChange={onChangeDate}
                  placeholder="กรุณาเลือกวันที่"
                  size="large"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {/* ค่าใช้จ่าย */}
        <Divider orientation="left">💵 ศาลสั่งให้ต้องจ่าย</Divider>

        <Form.Item label="ค่าฤชาศาล">
          <Form.Item name="courtFee1" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
          {/* <Form.Item name="courtFeeCheck" valuePropName="checked" noStyle>
              <Checkbox>รับผิด</Checkbox>
            </Form.Item> */}
        </Form.Item>

        <Form.Item label="ค่าติดตาม">
          <Form.Item name="trackingFeeEnforce1" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
        </Form.Item>

        <Form.Item label="ค่าทนายความ">
          <Form.Item name="lawyerFeeEnforce1" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
        </Form.Item>

        {/* จำเลยที่ร่วมคำพิพากษา */}
        {/* {showDefendantSection && ( */}
        <>
          <Divider orientation="left">
            <TeamOutlined /> จำเลยที่ร่วมคำพิพากษานี้
          </Divider>
          {radioDecide === "agreement" && (
            <Form.Item
              name="checkboxAll"
              valuePropName="checked"
              label={
                <Space>
                  <TeamOutlined />
                  <span>เลือกจำเลยทั้งหมด</span>
                  {allDefendants.length > 0 && (
                    <Tag color="blue">{allDefendants.length} คน</Tag>
                  )}
                </Space>
              }
            >
              <Checkbox onChange={onChangeCheckBoxAll}>เลือกทั้งหมด</Checkbox>
            </Form.Item>
          )}
          <Tooltip
            placement="bottom"
            title="เลือกจำเลยที่โดนพิพากษาในคำตัดสินนี้ !"
            arrow={mergedArrow}
          >
            <Form.Item
              label={
                <Space>
                  <TeamOutlined />
                  <span>เลือกจำเลย</span>
                  {checkboxTab1.length > 0 && (
                    <Tag color="blue">{checkboxTab1.length} คน</Tag>
                  )}
                </Space>
              }
              name="governmentOfficer1"
            >
              <DefendantCheckboxGroup
                tabNumber={1}
                defendants={allDefendants}
                selectedValues={checkboxTab1}
                onChange={handleCheckboxTab1Change}
                customerCustomerId={customerCustomerId}
                onAddClick={onAddDefendantClick}
                loading={loading}
                disabledDefendants={disabledDefendants} // ✅ เพิ่ม
              />
            </Form.Item>
          </Tooltip>
        </>
        {/* )} */}

        {/* หมายเหตุ */}
        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={5}
            placeholder="กรอกหมายเหตุ (ถ้ามี)"
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Space size="large">
              <Button
                size="large"
                onClick={handleCancel}
                icon={<CloseOutlined />}
                style={{ minWidth: 120 }}
              >
                ปิด
              </Button>
              {showNextButton &&
              checkboxTab1.length !== allDefendants.length ? (
                // ✅ ใช้ handleNextTab ที่มี validation
                <Button
                  type="primary"
                  size="large"
                  onClick={handleNextTab}
                  loading={loading}
                  style={{ minWidth: 120 }}
                >
                  คำพิพากษถัดไป →
                </Button>
              ) : (
                <Popconfirm
                  placement="topLeft"
                  title="อัพเดทข้อมูล"
                  description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                  onConfirm={() => form.submit()}
                  okText="ยืนยัน"
                  cancelText="ปิด"
                  okButtonProps={{ size: "large" }}
                  cancelButtonProps={{ size: "large" }}
                >
                  <Button
                    type="primary"
                    size="large"
                    icon={<SaveOutlined />}
                    loading={loading}
                    style={{ minWidth: 120 }}
                  >
                    บันทึก
                  </Button>
                </Popconfirm>
              )}
            </Space>
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default FormJudge1;
